import { useCallback } from 'react'
import { BestContactTimeOptionsType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'

export function useHandlers() {
  const { setFieldValue } = useFormikContext<
    ILeadFormModel | IAddOpportunityFormModel
  >()

  const handelChange = useCallback(
    (value: BestContactTimeOptionsType[] | null) => {
      setFieldValue(
        'preferredTimeOfContact',
        value?.map((row) => row.value),
      )
    },
    [],
  )

  return {
    handelChange,
  }
}
